module.exports = __webpack_public_path__ + "static/media/vuplex-logo.4253cfce.png";